import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function News10() {
  return (
    <Container>
      <br />
      <p style={{ color: "grey", fontSize: "1.5rem", margin: "2rem" }}>
        August 13, 2025
      </p>
      <h2
        style={{ color: "#003561", marginBottom: "1rem", marginLeft: "2rem" }}
      >
        Stratus Materials Releases and Begins Shipping LXMO-2, its 2nd
        Generation LMR CAM, to Customers and Partners
      </h2>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        PITTSBURGH, August 13, 2025/Business Wire -{" "}
        <a
          href="https://www.stratusmaterials.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Stratus Materials Inc.
        </a>{" "}
        , a company focused on the development and commercialization of lithium
        manganese-rich (LMR) cathode active material (CAM) for lithium-ion
        batteries, announces that, as of May 2025, it has transitioned to a
        second-generation cobalt-free “LXMO-2” CAM and started shipping to
        customers and partners. This progression to LXMO-2 further solidifies
        Stratus’s position as a clear leader in the rapidly emerging field of
        LMR CAMs.
      </p>

      <ul
        style={{
          color: "black",
          fontSize: "1.5rem",
          margin: "2rem",
          paddingLeft: "3rem",
        }}
      >
        <li style={{ marginBottom: "0.5rem" }}>
          <u>Versus other LMR offerings</u>, LXMO-2 provides superior stability
          in capacity and voltage compared to other LMRs, enabling best-in-class
          energy retention over battery lifetime. Less than 20% fade on capacity
          and less than 5% fade on average discharge voltage after 1,200 full
          DoD cycles with upper cutoff voltages exceeding 4.4 volts have been
          achieved <Link to="/technology#data-plot">[data plot]</Link> . In
          addition, the density of this material enables high energy cells, with
          well over 300 Wh/kg and 700 Wh/liter demonstrated. Finally, LXMO-2
          delivers unparalleled performance and stability without the use of CAM
          coatings or dopants, resulting in a simpler, more stable, and lower
          cost CAM solution.{" "}
        </li>
        <li>
          <u>Versus prior LXMO offerings from Stratus</u>, LXMO-2 offers
          improvements in terms of efficiency, specific capacity, rate
          performance, and discharge energy while maintaining superior safety,
          stability, manufacturability, processability, and cost advantages.{" "}
        </li>
      </ul>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Industry activity focused on elevating LMR material has increased
        significantly over the past 12 months, with several major electric
        vehicle OEMs recently announcing their intentions to deploy LMR in their
        next generation vehicles{" "}
        <a
          href="https://cleantechnica.com/2025/05/14/gm-ford-tease-new-game-changing-lmr-ev-batteries-but-where-is-waldo/"
          target="_blank"
          rel="noopener noreferrer"
        >
          [CleanTechnica May 14, 2025]
        </a>{" "}
        . If properly designed and stabilized, LMR can deliver a highly
        attractive value proposition: cells with energy densities at or above
        those of mid- or high-nickel NMCs, but with cost and safety profiles
        similar to those of LFP. At the systems level, the combination of LMR’s
        high safety and high energy density can result in pack-level energy
        densities that are up to twice those of NMC or LFP packs. Jay Whitacre,
        CEO of Stratus Materials commented: “The major pack-level energy density
        and cost advantages that are enabled by our patent-pending cobalt-free
        LXMO are substantial. EV OEMs and their suppliers gain highly attractive
        design freedom concerning pack size, system cost, and EV range that are
        currently unavailable. ”
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Since mid-2023, Stratus has been engaged with a broad set of leading EV
        OEMs, cell & pack manufacturers, and CAM producers to evaluate and
        optimize its LXMO CAM offerings and associated technologies. These
        efforts have validated the core advantages of LXMO over other competing
        CAMs, and have allowed Stratus to focus its ongoing innovation efforts
        on the product dimensions that are most important to its partners and
        customers. The most recent result of this customer-informed work is
        LXMO-2.
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <b>Pilot Line:</b> Stratus is also pleased to announce that it is in the
        final stages of standing up a 30-ton per year pilot manufacturing line
        in Pittsburgh, PA. This line, which will be operational in the 4th
        quarter of 2025, is key to demonstrating the scalability of LXMO
        material production and to supplying customers and partners with larger
        evaluation quantities in the coming quarters.
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <strong>ABOUT STRATUS MATERIALS</strong>
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        <a
          href="https://www.stratusmaterials.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Stratus Materials
        </a>{" "}
        is a U.S. based company focused on the development and commercialization
        of next-generation, LMR cathode active materials for lithium-ion
        batteries. Our mission is to disrupt the CAM supply chain by offering
        materials with a game-changing combination of performance, safety, and
        cost. Stratus is primarily focused on cathode solutions for light- and
        medium-duty electric vehicles, stationary energy storage solutions, and
        other applications with similar requirements. Stratus’s business model
        is licensing partnerships, where Stratus teams with large, existing CAM
        producers or users to produce and sell LXMO into the lithium-ion battery
        industry.
      </p>

      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Media Contact:
      </p>
      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Robyn Kennedy DeSocio
      </p>
      <p style={{ color: "black", fontSize: "1.5rem", margin: "2rem" }}>
        Email: marketing@stratusmaterials.com
      </p>

      <a
        style={{
          fontSize: "1.5rem",
          margin: "2rem",
          textDecoration: "None",
          display: "flex",
          justifyContent: "center",
        }}
        href="/news"
      >
        <strong style={{ textAlign: "center" }}>BACK TO NEWS</strong>
      </a>
      <br />
      <br />
    </Container>
  );
}

export default News10;
